import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { CodesLayout, RefrencesLayout } from "../Layout";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
function UserDefinedSublotTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
        const handleCodesFormLoad = useCallback(() => {
        }, []);
        const handleRefrencesFormLoad = useCallback(() => {
    
        }, []);
    return (
            <TabPanel height={"auto"}>
                <TabItem title="Codes">
                    <FormField
                        currrentUser={currentUser}
                        layoutId='AC557ADA-A539-4537-8BCD-EDB5025F5105'
                        layoutName='UserDefinedCodeForm'
                        defaultFormSchema={CodesLayout}
                        formFields={props.formFields}
                        setformFields={props.setformFields}
                        handleFieldValueChange={props.handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={props.formRefs}
                        onFormLoad={handleCodesFormLoad}
                        handleSelectedItemChange={props.handleSelectionChange}
                    />
                </TabItem>
                <TabItem title="References">
                    <FormField
                        currrentUser={currentUser}
                        layoutId='7B1AF2AB-D1B5-43D1-9A83-370DA2E9A1CB'
                        layoutName='UserDefinedRefForm'
                        defaultFormSchema={RefrencesLayout}
                        formFields={props.formFields}
                        setformFields={props.setformFields}
                        handleFieldValueChange={props.handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={props.formRefs}
                        onFormLoad={handleRefrencesFormLoad}
                        handleSelectedItemChange={props.handleSelectionChange}
                    />
                </TabItem>
            </TabPanel>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(UserDefinedSublotTab);